<template>
  <div>
      <promised :promise="promise" v-if="!hasError">
        <template #pending>
          <patient-card-widget-skeleton></patient-card-widget-skeleton>
        </template>
        <template #default>
          <p class="chart-widget__description"> {{ chartTitle }}</p>
          <highcharts :key="1" :options="chartOptions" ref="chart"></highcharts>
        </template>
        <template v-slot:rejected="error">
          <p>Error: {{ error.message }}</p>
        </template>
      </promised>
      <div v-else class="widget-permission-error">{{ errorMessage }}</div>
  </div>
</template>

<script>
import WidgetMixin from "@/components/mixins/WidgetMixin";
import PatientCardWidgetSkeleton from "@/components/skeletons/PatientCardWidgetSkeleton";
import { EventBus } from "@/lib/EventBus";
import GenericWidgetGuard from "@/components/permissions/GenericWidgetGuard";
import Highcharts from "highcharts"
import ChartMixin, {injectFakeDataAction} from "@/components/mixins/ChartMixin";

export default {
  name: "BarChartWidget",
  components: {PatientCardWidgetSkeleton},
  mixins: [WidgetMixin, ChartMixin],
  widget: {
    serviceMethod: 'getCharts',
    title: null,
    guard: GenericWidgetGuard
  },
  methods: {
    reflow() {
      if (this.$refs.chart) {
        this.$refs.chart.chart.reflow()
      }
    }
  },
  mounted() {
    EventBus.$on('reflow-chart', this.reflow)
  },
  beforeUnmount() {
    EventBus.$off('reflow-chart', this.reflow)
  },
  afterDataLoaded({ data: [{title, data, subtitle}]}) {
    injectFakeDataAction.call(this)
    if (this.widgetModel.settings.isCentralMonitoring) {
      this.emitSubtitle(title)
    } else {
      this.emitTitle(title)
      this.emitSubtitle(subtitle)
    }
    this.emitTitleTooltip(data.chart_description)

    let maxNumber = 0
    this.chartOptions.series = []

    if (Array.isArray(data.entries[0].y)) {
      this.chartOptions.plotOptions = {
        column: {
          stacking: 'normal',
          pointWidth: 25,
          dataLabels: {
            enabled: true
          }
        }
      }
      //TODO: quick fix for demo
      let entries = []
      data.entries.forEach(entry => {
        entries.push(...entry.y)
      });
      maxNumber = Math.max(...entries)
    } else {
      let entries = data.entries.map(entry => entry.y)
      maxNumber = Math.max(...entries)
    }
    if (data.start_time && data.interval_length) {
      this.chartOptions.xAxis = {
        type: 'datetime'
      }
      if (data.interval_length == 86400) {
        this.chartOptions.tooltip = {
          xDateFormat: '%A, %b %e'
        }
      }
      if (!this.chartOptions.plotOptions) {
        this.chartOptions.plotOptions = {}
      }
      this.chartOptions.plotOptions.series =  {
        pointStart: this.$helpers.getDate({ date: data.start_time }).valueOf(),
        pointInterval: data.interval_length * 1000
      }
    } else {
      this.chartOptions.xAxis = {
        categories: data.x_labels
      }
    }
    this.chartOptions.yAxis.max = maxNumber
    data.labels.forEach((label, index) => {
      let seriesData = []
      data.entries.forEach((entry) => {
        if (Array.isArray(entry.y)) {
          seriesData.push(Math.round(entry.y[index]))
        } else {
          seriesData.push(Math.round(entry.y))
        }
      })
      this.chartOptions.series.push({
        name: label,
        data: seriesData,
        color: Highcharts.getOptions().colors[index]
      })
    });

    this.applyStandardSettings(data)
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: (9 / 16 * 100) + '%',
          type: 'column'
        },
        yAxis: {
          visible: false,
          stackLabels: {
            enabled: true,
          },
          endOnTick: false
        },
        legend: {
          enabled: false
        },
        title: '',
        credits: {
          enabled: false
        },
        series: []
      }
    }
  }
}
</script>
